import React, { useEffect, useMemo } from 'react';
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { Loader } from '@trackman/web-shared-components';

import { observer } from 'mobx-react-lite';

import { useStores } from 'index';
import { AppCard, AppPageHeader } from 'components/ui';
import { t } from 'index';

import { SimpleTable } from 'components/Tables/SimpleTable';
import { TableCell } from '@trackman/web-shared-components';

export const TaggingAppDispatcher: React.FC = observer(() => {
  const { locationStore, apiServiceAxiosInstance: apiInstance } = useStores();

  useEffect(() => {
    locationStore.fetchLocations(apiInstance);
  }, [locationStore]);

  return (
    <div className='home-page' style={{ marginTop: '35px' }}>
      <AppPageHeader title={t('tagging_app_dispatcher')} />

      <AppCard title={`${t('matching_ip_addresses')}`}>
        <div className='w-100'>
          {locationStore.isLoading ? (
            <IsLoadingLocationComponent />
          ) : locationStore.locationResponse ? (
            <LocationsComponent locations={locationStore.locationResponse} isLoading={locationStore.isLoading} />
          ) : (
            <p>{t('no_data_found')}</p>
          )}
        </div>
      </AppCard>
    </div>
  );
});

const IsLoadingLocationComponent = () => {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <p>{t('trying_to_match_ip_address')}</p>
      <Loader />
    </div>
  );
};

const LocationsComponent = ({ locations, isLoading }: { locations: any; isLoading: boolean }) => {
  const openInNewTabHandler = (ipAddress: string) => {
    window.open(`http://${ipAddress}`, '_blank');
  };

  const showMetaInformation = (ipAddress: string, requestDate: string, resultsFound: boolean) => {
    return (
      <>
        <p className='font-weight-bold'>
          {resultsFound ? t('matching_fields_found_for_ip_address') : t('no_matching_fields_found_for_ip_address')} {ipAddress}
        </p>
        <p>
          {t('request_date')}: {new Date(requestDate).toUTCString()}
        </p>
      </>
    );
  };

  const columns = useMemo(
    () => [
      {
        id: 'systemName',
        accessor: 'systemName',
        Header: t('system_name'),
        width: 200,
      },
      {
        id: 'networkIpAddress',
        accessor: 'networkIpAddress',
        Header: t('network_ip_address'),
        width: 200,
      },
      {
        id: 'actions',
        Header: t('actions'),
        width: 100,
      },
    ],
    []
  );

  const renderCell = ({
    cellValue,
    columnHeader,
    columnId,
    row,
  }: {
    cellValue: string;
    columnHeader: string;
    columnId: string;
    row: any;
  }) => {
    if (columnId === 'actions') {
      return (
        <button
          className='btn btn-link'
          onClick={() => {
            openInNewTabHandler(row.networkIpAddress);
          }}
          title={t('open_in_new_tab')}
        >
          <span className='sr-only'>
            {t('open_in_new_tab')} {row.networkIpAddress}
          </span>
          <svg height='24' viewBox='0 0 24 24' width='24'>
            <path d='M0 0h24v24H0z' fill='none' />
            <path d='M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' />
          </svg>
        </button>
      );
    }
    return (
      <span className='overflow-ellipsis' title={`${cellValue?.trim() || '-'}`}>
        {cellValue?.trim() || '-'}
      </span>
    );
  };

  return (
    <>
      {locations.items && locations.items.length > 0 ? (
        <>
          {showMetaInformation(locations.clientIpAddress, locations.requestDateTime, true)}
          <SimpleTable
            isLoading={isLoading}
            renderCell={renderCell}
            onChangePage={(page) => {}}
            columns={columns}
            data={locations.items}
            page={1}
            rowsPerPage={100}
          />
        </>
      ) : (
        <div className='d-flex flex-column'>
          {showMetaInformation(locations.clientIpAddress, locations.requestDateTime, false)}
          <p>
            {t('contact_trackman_support_at')}
            <a className='ml-2' href='tel:+480 757 7652'>
              (480) 757 7652
            </a>
          </p>
        </div>
      )}
    </>
  );
};
